import ButtonPrompt from './ButtonPrompt';

export default ButtonPrompt;